import './Spinner.scss'; // You can define your own styles

interface SpinnerProps {
  styleClass?: string;
  message?: string;
};

const Spinner = (props: SpinnerProps) => {
  const { styleClass, message } = props;

  const renderMessage = () => {
    return (
      <div className="spinner-text my-2">
        <p>{message}</p>
      </div>
    );
  };

  return (
    <div className={`spinner-container ${styleClass && styleClass}`}>
      <div className="spinner"></div>
      {renderMessage()}
    </div>
  );
};

export default Spinner;
